module.exports = __webpack_public_path__ + "img/Rectangle 5.739b95aa.png";